import src from "IMAGE";
export default { src, width: 940, height: 550, blurWidth: 8, blurHeight: 5, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAYAAAB4ka1VAAAANUlEQVR42o2MOQ4AIAgE+f9DVYxHpS1sQUIFoZhis5Ohf6dkUE04jMGBsDuE4YQFnG81E72mB7eYDud1ZtwAAAAASUVORK5CYII="};
